/** 견적문의 "How it works" 단계 — 견적 설계 §5~§7 의 고객 흐름(디자인 → 요청 → 발행 → 주문) 그대로다. */
export interface QuoteStep {
  readonly title: string;
  readonly description: string;
}

export const QUOTE_STEPS: readonly QuoteStep[] = [
  { title: '상품 고르기', description: '스토어나 기획전에서 만들고 싶은 상품을 고릅니다.' },
  {
    title: '에디터에서 디자인',
    description: '상품 사진 위에 이미지와 문구를 올려 디자인하고 저장합니다.',
  },
  {
    title: '견적 요청',
    description: '수량과 인쇄 방식, 희망 납기일, 요청사항을 적어 견적을 요청합니다.',
  },
  {
    title: '확정견적 받고 주문',
    description: '담당자가 확인해 발행한 확정견적을 내 견적에서 보고 주문합니다.',
  },
];
